export default Intl.DateTimeFormat().resolvedOptions().timeZone;
